export enum CommonFieldTitles {
  title = 'systemSettings.wallbox.settings.common.title',
  deviceName = 'systemSettings.wallbox.settings.deviceName',
  numberPhases = 'systemSettings.wallbox.settings.numberPhases',
  sunModeActive = 'systemSettings.wallbox.settings.sunModeActive',
  minChargeCurrent = 'systemSettings.wallbox.settings.minChargeCurrent',
  cableLock = 'systemSettings.wallbox.settings.cable-lock',
  ledIntensity = 'systemSettings.wallbox.settings.led-intensity',
  maxChargePowerLimit = 'systemSettings.wallbox.settings.maxChargePowerLimit',
  maxChargeCurrentLimit = 'systemSettings.wallbox.settings.maxChargeCurrentLimit',
  minChargePower = 'systemSettings.wallbox.settings.minChargePower',
}

export enum CommonFieldNames {
  deviceName = 'deviceName',
  numberPhases = 'numberPhases',
  autoPhaseSwitchEnabled = 'autoPhaseSwitchEnabled',
  sunModeActive = 'sunModeActive',
  minChargeCurrent = 'minChargeCurrent',
  cableLock = 'cableLock',
  ledIntensity = 'ledIntensity',
  upperCurrentLimit = 'upperCurrentLimit',
  maxChargeCurrent = 'maxChargeCurrent',
  maxChargePower = 'maxChargePower',
  minChargePower = 'minChargePower',
}

export enum CommonFieldLabels {
  deviceName = 'systemSettings.wallbox.settings.deviceName',
  minChargeCurrent = 'systemSettings.wallbox.settings.minChargeCurrent',
  ledIntensity = 'systemSettings.wallbox.settings.led-intensity',
  upperCurrentLimit = 'systemSettings.wallbox.settings.currentLimit',
  maxChargeCurrent = 'systemSettings.wallbox.settings.maxCharge',
  maxChargePower = 'systemSettings.wallbox.settings.maxChargePower',
  minChargePower = 'systemSettings.wallbox.settings.minChargePower',
}

export const FALLBACK_VALUE_EDSN = {
  /* Lower bound for minChargePower (W) */
  lowerChargePowerLimit: 1000,
  /* Upper bound for maxChargePower (W) */
  upperChargePowerLimit: 11000,
  /* Lower bound for maxDischargePower (W)*/
  lowerDischargePowerLimit: 500,
  /* Upper bound for maxDischargePower (W) */
  upperDischargePowerLimit: 11000,

  minChargePower: 1000,
  maxChargePower: 11000,
  maxDischargePower: 11000,
}
